module.exports = __webpack_public_path__ + "static/media/fade-withsparkles.8386d3da.jpg";